import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Consumers from '../components/consumers/consumers';

const ReferralsPage = () => (
  <Layout>
    <SEO title="Consumers" />  
    <Consumers/>
  </Layout>

)

export default ReferralsPage